export const CHECKLIST_BUTTON_VIEW = 'checklist-button-view';
